import type { ComponentStyle } from "@yamada-ui/core"

export const FormatNumber: ComponentStyle<"FormatNumber"> = {}
